export default class Cycle {
  constructor(targetImageElement, images = [], interval = 500) {
    this.element = targetImageElement;
    this.index = 0;
    this.images = images;
    this.timer = setInterval(_ => {
      this.index = (this.index + 1 == this.images.length) ? this.index = 0 : this.index + 1;
      this.element.src = this.images[this.index];
    }, interval);
  }
  destroy() {
    this.element.src = '';
    clearInterval(this.timer);
  }
}


// WEBPACK FOOTER //
// ./source/javascript/utilities/cycle.js